import EagerComponent from '@components/EagerComponent'
import News from '@reusable-modules/News'

const NewsComponent = (props) => <EagerComponent className='News'><News {...props} /></EagerComponent>

export default NewsComponent